/**
 * Created by TNAN on 1/15/18.
 */

class RoundBorderTab {
  id: number;
  title: string;
  data: any[];
  isSelected: boolean;
  active: boolean;
  value: string;
  constructor(props?: any) {
    this.id = props?.id || 0;
    this.title = props?.title || '';
    this.data = props?.data || [];
    this.isSelected = props?.isSelected || false;
    this.active = props?.active || false;
    this.value = props?.value || '';
  }

  static mappingObject(roundBorderTab: any): RoundBorderTab {
    const tab = new RoundBorderTab();
    tab.id = roundBorderTab.id || 0;
    tab.title = roundBorderTab.title || '';
    tab.isSelected = roundBorderTab.isSelected || false;
    tab.active = roundBorderTab.active || false;
    tab.value = roundBorderTab.value || '';
    return tab;
  }
}

export default RoundBorderTab;
